module.exports = {
    title: "College Stream",
    crud: {
        view: "View College Stream",
    },
    table: {
        name: "Name",
        user: "User Name",
        status: "Status",
    },
    form: {
        name: "Name",
        user: "User Name",
        status: "Status",
    }
}